import Vue from 'vue'
import i18n from './i18n.plugin'
import Vuetify, { colors } from 'vuetify/lib'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'vuetify/dist/vuetify.min.css'

Vue.use(Vuetify)

const opts = {
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        background: '#FAFCFC',
        box_menu: '#fff',
        application: '#FAFCFC',
        appBar: colors.blueGrey.darken4,
        primary: colors.blueGrey.darken4,
        secondary: colors.blueGrey.darken3,
        tertiary: colors.blueGrey.lighten3,
        quaternary: colors.blueGrey.darken3,
        blocks_text: colors.blueGrey.darken1,
        blocks_line: '#F3F3F2',
        accent: colors.blueGrey.lighten4,
        timid: colors.blueGrey.darken1,
        dinamo: '#C4A932',
        mostardPastel: '#EAE0B7',
        petrolPastel: '#B4C6CC',
        contrasty: colors.shades.black,
        text_secondary: colors.blueGrey.darken3,
        text_secondary_invert: colors.blueGrey.lighten4,
        text_red: colors.red.base,
        page_title: '#354041',
        // key icons
        asym_icon_color: colors.red.base,
        sym_icon_color: colors.orange.base,
        // user icons
        operator_icon_color: colors.red.base,
        sysPerm_icon_color: colors.orange.base,
        //
        default_icon_color: colors.shades.black,
        // Chart
        cpuChartLine: colors.blue.base,
        ramChartLine: '#67df9c',
        selectedListItemBg: '#e6e7e8',
        soloTxtFldBg: '#F0F0F0',
        highlight: '#E9E9E9',
        icon_color: '#7d8590',
        context_title_color: '#7d8590'
      },
      dark: {
        background: '#000000',
        box_menu: '#3b3b3b',
        application: '#000000',
        appBar: colors.blueGrey.darken4,
        primary: colors.blueGrey.lighten3,
        quaternary: colors.blueGrey.lighten4,
        blocks_line: '#404040',
        timid: colors.blueGrey.lighten3,
        dinamo: '#C4A932',
        mostardPastel: '#EAE0B7',
        petrolPastel: '#B4C6CC',
        contrasty: colors.shades.white,
        text_secondary: colors.blueGrey.lighten4,
        text_secondary_invert: colors.blueGrey.darken3,
        text_red: colors.red.base,
        page_title: colors.blueGrey.lighten5,
        // key icons
        asym_icon_color: colors.red.base,
        sym_icon_color: colors.orange.base,
        // user icons
        operator_icon_color: colors.red.base,
        sysPerm_icon_color: colors.orange.base,
        //
        default_icon_color: colors.grey.base,
        // Chart
        cpuChartLine: colors.blue.base,
        ramChartLine: '#67df9c',
        selectedListItemBg: '#424446',
        soloTxtFldBg: '#424242',
        highlight: '#616161',
        icon_color: '#7d8590',
        context_title_color: '#7d8590'
      }
    }
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  }
}

export default new Vuetify(opts)
